export const DASHBOARD_VIEW_OPTION_TYPES = {
  IN_PROGRESS: {
    name: "In Progress",
    value: 1
  },
  COMPLETED: {
    name: "Completed",
    value: 4
  }
};

export const DASHBOARD_VIEW_OPTIONS = [
  { name: DASHBOARD_VIEW_OPTION_TYPES.IN_PROGRESS.name, value: DASHBOARD_VIEW_OPTION_TYPES.IN_PROGRESS.value, index: 0 },
  { name: DASHBOARD_VIEW_OPTION_TYPES.COMPLETED.name, value: DASHBOARD_VIEW_OPTION_TYPES.COMPLETED.value, index: 2 }
];

export const SAMPLE_METRICS = [
  { metricName: "Delivered", value: 130 },
  { metricName: "Unique Opens", value: 125 },
  { metricName: "Link Clicks", value: 110 },
  { metricName: "Unsubscribes", value: 1 }
];

export const CAMPAIGN_TYPES = {
  PREPAYMENT: {
    id: "a7ef58c8-7619-466d-8860-fcc2c5ba4f4d",
    name: "Prepayment"
  },
  VALUATION_SENSITIVITY: {
    id: "a8ef58c8-7619-466d-8860-fcc2c5ba4f4d",
    name: "Valuation Sensitivity"
  },
  DEBT_WITH_US: {
    id: "a9ef58c8-7619-466d-8860-fcc2c5ba4f4d",
    name: "Your Debt With Us"
  }
};

export const CampaignIdToNames = {
  "a7ef58c8-7619-466d-8860-fcc2c5ba4f4d": "Prepayment",
  "01870d97-5892-4b8f-aab1-94102b3213cb": "Cash Out Proceeds",
  "4d595e8a-552d-4ba4-ad7e-0440b8872968": "Refi Breakeven",
  "a8ef58c8-7619-466d-8860-fcc2c5ba4f4d": "Valuation Sensitivity",
  "a9ef58c8-7619-466d-8860-fcc2c5ba4f4d": "Your Debt With Us"
};

export const IN_PROGRESS_DASHBOARD_HEADERS = [
  {
    name: "Email Name"
  },
  {
    name: "Email Type"
  },
  {
    name: "Scheduled Date"
  },
  {
    name: "Includes"
  },
  {
    name: "Created On"
  },
  {
    name: "Created By"
  }
];

export const COMPLETED_DASHBOARD_HEADERS = [
  {
    name: "Email Name"
  },
  {
    name: "Email Type"
  },
  {
    name: "Sent On"
  },
  {
    name: "Includes"
  },
  {
    name: "Created On"
  },
  {
    name: "Created By"
  }
];

